import React from 'react';
import { Phone, ExternalLink, Linkedin, MapPin } from 'lucide-react';
import { LOGOS, CONTACT } from '../lib/constants';
import { ContactEmail } from './ui/ContactEmail';
const serviceLinks = [{
  label: 'Managed Services',
  accent: '#0AA77E'
}, {
  label: 'Security',
  accent: '#D2223D'
}, {
  label: 'Hosting',
  accent: '#57578E'
}, {
  label: 'Voice',
  accent: '#F2612A'
}, {
  label: 'Services overview'
}];
const columns: {
  title: string;
  links: string[];
}[] = [{
  title: 'Industries',
  links: ['Legal', 'Accounting', 'Engineering', 'Health']
}, {
  title: 'Why CT Group',
  links: ['Our Difference', 'Our Own Infrastructure', 'Client Outcomes', 'Independent IT Review', 'Our Story', 'Careers']
}, {
  title: 'Resources',
  links: ['Essential Eight Data Pack', 'Switching Providers Guide', 'IT Review Explainer', 'Insights', 'FAQ']
}];
const cities = ['Perth', 'Melbourne', 'Sydney', 'Brisbane', 'Adelaide'];
function footerHref(label: string) {
  if (['Managed Services', 'Security', 'Hosting', 'Voice', 'Services overview'].includes(label)) return '#services';
  if (['Legal', 'Accounting', 'Engineering', 'Health'].includes(label)) return '#industries';
  if (['Our Difference', 'Our Own Infrastructure'].includes(label)) return '#difference';
  if (label === 'Client Outcomes') return '#outcomes';
  if (label === 'Independent IT Review') return '#it-review';
  if (label === 'Our Story') return '#leadership';
  if (label === 'Careers') return 'https://ctgroup.com.au/jobs/';
  if (label === 'FAQ') return '#faq';
  return 'https://ctgroup.com.au/media-events/';
}
export function Footer() {
  return <footer id="footer-contact" className="w-full bg-navy pt-16 text-white/80" data-id="element-19" data-mp="cw34v4htea64">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-20" data-mp="qtrok905bb9l">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-21" data-mp="mspqhvhyt597">
          {/* brand */}
          <div data-id="element-22" data-mp="tw5w602sbejk">
            <span className="inline-flex items-center rounded-xl bg-white px-4 py-3 shadow-sm" data-id="element-23" data-mp="two25of9174o">
              <img src={LOGOS.main} alt="CT Group" className="h-9" data-id="element-24" data-mp="yupl89cod6g5" />
            </span>
            <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-white/70" data-id="element-25" data-mp="13s97nwjj0pj6">
              End-to-end managed IT for professional services firms.
            </p>
            <p className="mt-2 text-[12px] font-semibold uppercase tracking-[0.14em] text-ct-light/70" data-id="element-26" data-mp="1clumffvoy6sl">
              Efficiency through IT
            </p>
            <p className="mt-4 max-w-xs text-[12px] leading-relaxed text-white/70" data-id="element-27" data-mp="1hiulh6u4i9a7">The Garden Office Park, Ground Level, Building B, 355 Scarborough Beach Road, Osborne Park WA 6017</p>
            <p className="mt-2 text-[11px] text-white/65" data-id="element-28" data-mp="1rid15b3038wg">CT Group Solutions Pty Ltd · ABN 15 605 756 367</p>
            <div className="mt-6 space-y-2.5 text-[14px]" data-id="element-29" data-mp="3oczplbp94j6k">
              <a href={CONTACT.phoneHref} className="flex items-center gap-2 text-white/80 hover:text-white" data-id="element-30" data-mp="3t9ge470d4zk6">
                <Phone className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-31" data-mp="2agyeh6q4czor" />{' '}
                {CONTACT.phone}
              </a>
              <ContactEmail label="Email CT Group" className="min-h-0 text-[14px] text-white/80 hover:text-white" iconClassName="text-ct-cyan" data-id="element-32" data-mp="21mjyt31ofn54" />
              <a href="https://solutions.ctgroup.com.au/portal" className="flex items-center gap-2 text-white/80 hover:text-white" data-id="element-33" data-mp="2tehoodobcocr">
                <ExternalLink className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-34" data-mp="2kdb49tijmte8" />{' '}
                Client Portal
              </a>
              <a href="https://www.linkedin.com/company/ct-group-solutions" className="flex items-center gap-2 text-white/80 hover:text-white" data-id="element-35" data-mp="2fezufis90iw0">
                <Linkedin className="h-4 w-4 text-ct-cyan" aria-hidden data-id="element-36" data-mp="13yi7qaegdumk" />{' '}
                LinkedIn
              </a>
            </div>
          </div>

          {/* services */}
          <div data-id="element-37" data-mp="2wmg1l22crzi6">
            <h3 className="font-display text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-38" data-mp="2wmzjwjvx0pwq">
              Services
            </h3>
            <ul className="mt-4 space-y-2.5 text-[14px]" data-id="element-39" data-mp="2iwmbkgf4396v">
              {serviceLinks.map(s => <li key={s.label} data-id="element-40" data-mp="2nue153saaj7w">
                  <a href={footerHref(s.label)} className="flex items-center gap-2 text-white/70 hover:text-white" data-id="element-41" data-mp="3bjqi4pturvkr">
                    {s.accent && <span className="h-2 w-2 rounded-full" style={{
                  background: s.accent
                }} aria-hidden data-id="element-42" data-mp="31m2ch4upl3nt" />}
                    <span className={s.accent ? '' : 'ml-4'} data-id="element-43" data-mp="1q8qfndxd9lb5">{s.label}</span>
                  </a>
                </li>)}
            </ul>
          </div>

          {columns.slice(0, 2).map(col => <div key={col.title} data-id="element-44" data-mp="1in4r1fahlqcq">
              <h3 className="font-display text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-45" data-mp="1ilteapz2d89h">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2.5 text-[14px]" data-id="element-46" data-mp="1wk9st3364326">
                {col.links.map(l => <li key={l} data-id="element-47" data-mp="13xyi2zluklrn">
                    <a href={footerHref(l)} className="text-white/70 hover:text-white" data-id="element-48" data-mp="13x6yyo9fsgi9">
                      {l}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-10 border-t border-white/10 pt-8 sm:grid-cols-2" data-id="element-49" data-mp="1dp2w9x3p82lf">
          <div data-id="element-50" data-mp="18vqm2rzrnyc7">
            <h3 className="font-display text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-51" data-mp="18v8eiz7nlxoz">
              Resources
            </h3>
            <ul className="mt-4 space-y-2.5 text-[14px]" data-id="element-52" data-mp="g95srlzqdc60">
              {columns[2].links.map(l => <li key={l} data-id="element-53" data-mp="2g9lxnyrpb2j2">
                  <a href={footerHref(l)} className="text-white/70 hover:text-white" data-id="element-54" data-mp="2gadhkcbxrbti">
                    {l}
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-55" data-mp="2q18fidyjnzus">
            <h3 className="font-display text-[14px] font-bold uppercase tracking-wide text-white" data-id="element-56" data-mp="2q2syr7ferwdc">
              Locations
            </h3>
            <ul className="mt-4 space-y-2.5 text-[14px]" data-id="element-57" data-mp="1xckqq8el6sch">
              {cities.map(c => <li key={c} className="flex items-center gap-2 text-white/70" data-id="element-58" data-mp="22acjf4n22ihq">
                  <MapPin className="h-3.5 w-3.5 text-ct-cyan" aria-hidden data-id="element-59" data-mp="27a77l0fg4tz3" />
                  {c}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/10 py-6 text-[13px] text-white/70 sm:flex-row sm:items-center" data-id="element-60" data-mp="2b97naa2mnghv">
          <p data-id="element-61" data-mp="3mpedii0ynu03">© {new Date().getFullYear()} CT Group. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-62" data-mp="1b3m1rex8qn3m">
            <a href="https://ctgroup.com.au/privacy-policy/" className="hover:text-white" data-id="element-63" data-mp="1b2kn70h0nih5">
              Privacy Policy
            </a>
            <a href="https://ctgroup.com.au/terms-and-conditions/" className="hover:text-white" data-id="element-64" data-mp="12ashf32xsxiw">
              Terms and Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>;
}